<h1>Регистрация</h1>
<small class="auth-hint">Уже есть учетная запись? <a routerLink="/sign-in">Войти</a></small>

<form (submit)="onFormSubmitClick()">

  <div class="form-floating mb-3">
    <input type="text" class="form-control" id="username" name="username" [(ngModel)]="username" required (ngModelChange)="clearUsernameErrors()">
    <label for="username">Логин</label>
  </div>

  <div class="form-floating mb-3">
    <input type="password" class="form-control" id="password" name="password" [(ngModel)]="password" required (ngModelChange)="clearPasswordErrors()">
    <label for="password">Пароль</label>
  </div>

  <div class="form-floating">
    <input type="password" class="form-control" id="repeatedPassword" name="repeatPassword" [(ngModel)]="repeatedPassword" required (ngModelChange)="clearPasswordErrors()">
    <label for="repeatedPassword">Повторите пароль</label>
  </div>

  <div class="mb-4">
    <div class="invalid-feedback d-block" *ngIf="!passwordsMatch">
      Пароли должны совпадать.
    </div>
    <div class="invalid-feedback d-block" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>
  

  <button class="btn btn-primary w-100" type="submit">Зарегистрировать</button>
</form>
